import { render, staticRenderFns } from "./communicationRecord.vue?vue&type=template&id=26b92644&scoped=true"
import script from "./communicationRecord.vue?vue&type=script&lang=js"
export * from "./communicationRecord.vue?vue&type=script&lang=js"
import style0 from "./communicationRecord.vue?vue&type=style&index=0&id=26b92644&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b92644",
  null
  
)

export default component.exports